import { Box, Skeleton } from '@mui/material';
import { ContainedText } from '../../../../ContainedText';
import { ContainedTextList } from '../../../../ContainedTextList';

interface CardCategoriesProps {
  categories?: string[];
  isLoading?: boolean;
  initialWidth?: number;
  gap?: number;
  paddingX?: number;
}

export const CardCategories = ({
  categories,
  isLoading,
  initialWidth,
  gap,
  paddingX,
}: CardCategoriesProps) => {
  const spacingProps = {
    gap: gap ?? 8,
    paddingX: paddingX ?? 8,
    initialWidth: initialWidth ?? 298,
  };
  console.log(spacingProps);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: `${spacingProps.gap}px`,
        }}
      >
        <Skeleton variant="rounded">
          <ContainedText>Mental Health</ContainedText>
        </Skeleton>

        <Skeleton variant="rounded">
          <ContainedText>Respiratory</ContainedText>
        </Skeleton>

        <Skeleton variant="rounded">
          <ContainedText>Healthy Living</ContainedText>
        </Skeleton>
      </Box>
    );
  }

  return (
    <ContainedTextList
      containerDataTestId="app-card-categories"
      items={categories ?? []}
      spacing={spacingProps}
    />
  );
};
